module.exports = __webpack_public_path__ + "static/media/spain-icon.2d451b3c.svg";